import { ViewConfig } from "@lib/views";
import { ViewTableMeta } from "@hooks/view/useViewTableMeta";
import { DATE_COLUMN_SIZE } from "@design-system/ViewTable/DefaultColumnSizes";
import { AuditLogRuleCondition } from "@common/types/auditLog";
import { BatchGroupDateCell } from "../cells/BatchGroupDateCell";
import { BatchGroupCountCell } from "../cells/BatchGroupCountCell";
import { BatchGroupConditionsCell } from "../cells/BatchGroupConditionsCell";
import { BatchGroupActionsCell } from "../cells/BatchGroupActionsCell";

export interface BatchGroupRow {
    id: string;
    sourceId: string;
    count: number;
    date: Date;
    isReverted: boolean;
    ruleConditions?: AuditLogRuleCondition[];
}

export interface BatchGroupTableCallbacks {
    onRevert?: (row: BatchGroupRow) => void;
    onExpand?: (row: BatchGroupRow) => void;
}

export type BatchGroupTableMeta = ViewTableMeta<
    BatchGroupTableCallbacks,
    unknown
>;

export enum BatchGroupColumn {
    DATE = "date",
    COUNT = "count",
    CONDITIONS = "conditions",
    ACTIONS = "actions",
}

export const batchGroupsViewConfig: ViewConfig<
    BatchGroupRow,
    BatchGroupColumn,
    never
> = {
    columns: {
        [BatchGroupColumn.DATE]: {
            accessorKey: "date",
            name: "Time",
            header: "",
            cell: BatchGroupDateCell,
            immutable: true,
            ...DATE_COLUMN_SIZE,
        },
        [BatchGroupColumn.COUNT]: {
            accessorKey: "count",
            name: "Transactions",
            header: "Transactions",
            cell: BatchGroupCountCell,
            minSize: 120,
            maxSize: 200,
        },
        [BatchGroupColumn.CONDITIONS]: {
            accessorKey: "ruleConditions",
            name: "Conditions",
            header: "Conditions",
            cell: BatchGroupConditionsCell,
            minSize: 200,
            maxSize: 800,
        },
        [BatchGroupColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            cell: BatchGroupActionsCell,
            minSize: 100,
            maxSize: 100,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
